import { render, staticRenderFns } from "./CreateSignatory.vue?vue&type=template&id=60bc4826&scoped=true"
import script from "./CreateSignatory.vue?vue&type=script&lang=js"
export * from "./CreateSignatory.vue?vue&type=script&lang=js"
import style0 from "./CreateSignatory.vue?vue&type=style&index=0&id=60bc4826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bc4826",
  null
  
)

export default component.exports